import { Link } from "react-router-dom";
import React from "react";
const user = JSON.parse(localStorage.getItem("user"));

export default function TopbarIconLogo() {
  return (
    <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
      <Link
        className="navbar-brand brand-logo"
        to={true ? "/dashboard" : "/dashboard/orders/pending"}
      >
        <img
          src="/images/icons/logo.png"
          alt="logo"
          className="lg-logo-image"
        />
      </Link>

      <Link className="navbar-brand brand-logo-mini" to="dashboard">
        <img src="/images/icons/Fav_ic@2x.png" alt="logo" />
      </Link>
    </div>
  );
}
